<div class="invoice">
    @if (loading) {
        <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
    } @else if (!loading && currentInvoice) {
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Invoice"></ws-bread-crumbs>
        <div>
            <div class="card panel-flat-color primary-panel">
                <div class="panel-flat-header">
                    <div class="header-icon"><i class="fa fa-pie-chart"></i></div>
                    <h3>Invoice</h3>
                    <div class="float-end header-button-container" [class.invisible]="callInProgress || loading">
                        @if (!editMode && !taskOnlyEditMode) {
                            <button type="button"
                                    class="ace-btn btn-text has-icon btn-primary"
                                    (click)="setEditMode()">
                                <i class="fa fa-pencil"></i>
                            </button>
                        }
                        @if (editMode || taskOnlyEditMode) {
                            <button type="button"
                                    class="ace-btn btn-text has-icon btn-primary"
                                    (click)="cancelEdit()">
                                <i class="fa fa-close"></i>
                            </button>
                        }
                    </div>
                </div>
                <div class="panel-flat-body form-inline">
                    @if (loading) {
                        <div class="text-center" style="margin-top: 50px;">
                            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                        </div>
                    }
                    @if (!loading) {
                        <div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Contract Type:</label>
                                    @if (!editMode || !canChangeContractType) {
                                        <span
                                            [ngClass]="{'overridden': currentInvoice.contractServiceType !== currentInvoice.defaultContractServiceType}">{{ invoiceService.contractServiceName(currentInvoice.contractServiceType) }}</span>
                                    }
                                    @if (currentInvoice.contractServiceType == ContractServiceType.Appeal && currentInvoice.isAdHoc) {
                                        <span> (ad hoc)</span>
                                    }
                                    @if (editMode && canChangeContractType) {
                                        <select [(ngModel)]="currentInvoice.contractServiceType"
                                                (ngModelChange)="onContractServiceTypeChange()"
                                                class="form-select form-select-sm">
                                            @for (type of appealContractTypes; track type) {
                                                <option [value]="type.value">{{ type.name }}</option>
                                            }
                                        </select>
                                    }
                                </div>
                                <div class="col-md-4">
                                    <label>Company:</label>
                                    <span>
                                    <a anchor-route
                                       [sref]="{ target: 'company', options: { companyId: currentInvoice.companyId } }"
                                       [isTargetBlank]="true"
                                       rel="noreferrer">
                                        {{ currentInvoice.companyName }}
                                    </a>
                                </span>
                                </div>
                                <div class="col-lg-4">
                                    <label style="width: 150px;">Processing Instructions: </label>
                                    <div class="position-relative">
                                <textarea class="form-control w-100 position-absolute"
                                          style="height: 80px; z-index: 2;"
                                          [disabled]="!editMode"
                                          [(ngModel)]="currentInvoice.processingInstructions">
                                </textarea>
                                    </div>
                                </div>
                                <div class="w-auto pull-right position-absolute" style="right:1em;">
                                    <entity-attachments buttonClass="has-icon"
                                                        [modalData]="attachmentData"
                                                        [(hasAttachments)]="currentInvoice.hasAttachments">
                                    </entity-attachments>
                                    <entity-comments buttonClass="has-icon"
                                                     [modalData]="commentData"
                                                     [(hasComments)]="currentInvoice.hasComments"
                                                     (hasCommentsChange)="currentInvoice.hasComments = $event">
                                    </entity-comments>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>RIBS Due Date:</label>
                                    <weissman-datetime [readOnly]="!editMode"
                                                       [dateOnly]="true"
                                                       [(inputDate)]="currentInvoice.dueDate">
                                    </weissman-datetime>
                                </div>
                                <div class="col-md-4">
                                    <label>Account Handler:</label>
                                    <span>{{ currentInvoice.accountHandler.firstName }} {{ currentInvoice.accountHandler.lastName }}</span>
                                </div>
                            </div>
                            @if (enableInvoiceUBR && (currentInvoice.isUBR || currentInvoice.invoiceUBRNumber)) {
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>UBR Request #:</label>
                                        @if (currentInvoice.invoiceUBRNumber) {
                                            <span>{{ currentInvoice.invoiceUBRNumber }}</span>
                                        }
                                        @if (!currentInvoice.invoiceUBRNumber) {
                                            <span>Draft</span>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="row">
                                <div class="col-md-4">
                                    <label>RIBS Request #:</label>
                                    @if (currentInvoice.invoiceNumber) {
                                        <span>{{ currentInvoice.invoiceNumber }}</span>
                                    }
                                    @if (!currentInvoice.invoiceNumber) {
                                        <span>Draft</span>
                                    }
                                </div>
                                @if (currentInvoice.siteId) {
                                    <div class="col-md-4">
                                        <label>Site ST-Name:</label>
                                        <span>
                                        <a anchor-route
                                           [sref]="{ target: 'site', options: {companyId: currentInvoice.companyId, siteId: currentInvoice.siteId} }"
                                           [isTargetBlank]="true"
                                           rel="noreferrer">
                                            {{ currentInvoice.siteState.abbr }} - {{ currentInvoice.siteName }}
                                        </a>
                                    </span>
                                    </div>
                                }
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Status:</label>
                                    <a style="cursor: pointer"
                                       (click)="launchTaskModal()">{{ currentInvoice.taskSummary[0].status }}</a>
                                </div>
                                <div class="col-md-4">
                                    <label>Recipient:</label>
                                    <invoice-recipient-lookup #invoiceRecipientLookup
                                                              [editMode]="editMode"
                                                              [invoice]="currentInvoice">
                                    </invoice-recipient-lookup>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>UBR:</label>
                                    <ws-switch [(ngModel)]="currentInvoice.isUBR"
                                               (ngModelChange)="setButtonText()"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                                <div class="col-md-4">
                                    <label>Third Party Approval Date:</label>
                                    <weissman-datetime [readOnly]="!editMode"
                                                       [dateOnly]="true"
                                                       [(inputDate)]="currentInvoice.thirdPartyApprovalDate"
                                                       helpTooltip
                                                       tooltipText="Latest appeal savings date when type is Appeal, otherwise current date."
                                                       position="right">
                                    </weissman-datetime>
                                </div>
                                <div class="col-md-4">
                                    <label style="margin-bottom: 0;">Terms:</label>
                                    <hr style="margin-top: 0; margin-bottom: 7px;">
                                    @if (editMode && companyAppealContractTerms.length > 1) {
                                        <select name="terms"
                                                [ngModel]="currentContractTermDetailId"
                                                (ngModelChange)="onContractTermChange($event)"
                                                class="form-select form-select-sm">
                                            @for (term of companyAppealContractTerms; track term) {
                                                <option [value]="term.contractTermDetailId">
                                                    <term-rates-and-fees [term]="term"
                                                                         [usePercent]="true"></term-rates-and-fees>
                                                </option>
                                            }
                                        </select>
                                    }
                                    @if (!editMode || companyAppealContractTerms.length <= 1) {
                                        <div style="display: flex; justify-content: space-between;"
                                             [class.overridden]="isContractTermOverridden">
                                            <term-rates-and-fees [term]="contractTerm"
                                                                 [usePercent]="true"></term-rates-and-fees>
                                            @if (currentInvoice.contractTermDetailRemarks) {
                                                <button
                                                    class="ace-btn has-icon"
                                                    triggers="mouseenter:mouseleave"
                                                    [popover]="currentInvoice.contractTermDetailRemarks">
                                                    <i class="fa fa-commenting"></i>
                                                </button>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (isRyanLegalServiceEnabled) {
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>RLS:</label>
                                        <input class="form-check-input"
                                               [disabled]="!editMode"
                                               type="checkbox"
                                               [(ngModel)]="currentInvoice.isRyanLegalServices"
                                               (ngModelChange)="onIsRyanLegalServicesChanged()">
                                    </div>
                                </div>
                            }
                            <!-- INVOICE DETAILS COMPONENT -->
                            <invoice-details-old
                                [currentInvoice]="currentInvoice"
                                [editMode]="editMode"
                                [loading]="loading"
                                [cachedInvoice]="cachedInvoice">
                            </invoice-details-old>
                            <!-- FEE ALLOCATION COMPONENT -->
                            <fee-allocation
                                [currentInvoiceAmount]="currentInvoice.invoiceAmount"
                                [currentInvoice]="currentInvoice"
                                [editMode]="editMode"
                                (engagementChanged)="invoiceRecipientLookup.getRecipientList()">
                            </fee-allocation>
                            @if (editMode) {
                                <button type="button"
                                        class="ace-btn btn-primary btn-danger float-end"
                                        tooltip="Delete Invoice"
                                        (click)="delete()"
                                        [disabled]="callInProgress || loading || !currentInvoice || !currentInvoice.canBeDeleted">
                                    Delete
                                </button>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="action-footer">
            <div class="action-buttons-row" style="margin-top: 10px; padding: 0px 75px;">
                <div class="float-start">
                    @if (editMode) {
                        <button type="button"
                                [disabled]="callInProgress || loading"
                                tooltip="Save Invoice"
                                (click)="save()"
                                class="ace-btn btn-sm btn-primary">Save
                        </button>
                    }
                    @if (showCompleteButton()) {
                        <button type="button"
                                [disabled]="callInProgress || loading"
                                (click)="complete()"
                                class="ace-btn btn-sm btn-secondary">{{ completeText }}
                        </button>
                    }
                    @if (callInProgress) {
                        <span style="margin-left: 4px;">
                        <ws-ace-loader [inline]="true"></ws-ace-loader>
                    </span>
                    }
                </div>
                <div class="float-end">
                    @if (editMode && taskList) {
                        <button type="button"
                                tooltip="Skip Invoice"
                                [disabled]="callInProgress || loading"
                                (click)="skipInvoice()"
                                class="ace-btn btn-sm btn-primary">{{ closeText }}
                        </button>
                    }
                </div>
            </div>
        </div>
    }
</div>

